import { getContainer } from "@neru/base/utils";
import { createRoot } from "react-dom/client";

import reportWebVitals from "./reportWebVitals";

if (!import.meta.env.PROD && import.meta.env.VITE_MOCK) {
  import("@neru/mock/worker");
}

import("./Bootstrap").then(async (module) => {
  const rootElement = getContainer();
  const root = createRoot(rootElement);

  root.render(module.default({}));

  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
});
